export { default, getStaticProps } from 'src/pages/HelpCenter/pages/HelpCenterTopic'
